const compare = (v1: unknown, v2: unknown) => String(v1) === String(v2);

export default compare;
